/**
 * @desc 根据sku判断供应商报价
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierQuotation.getOrderRatio.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/getOrderRatio`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
